// src/assets/wingoAssets.js

import red from '@/assets/img/wingo/red.png'
import green from '@/assets/img/wingo/green.png'
import violet from '@/assets/img/wingo/violet.png'

import img0 from '@/assets/img/wingo/0.png'
import img1 from '@/assets/img/wingo/1.png'
import img2 from '@/assets/img/wingo/2.png'
import img3 from '@/assets/img/wingo/3.png'
import img4 from '@/assets/img/wingo/4.png'
import img5 from '@/assets/img/wingo/5.png'
import img6 from '@/assets/img/wingo/6.png'
import img7 from '@/assets/img/wingo/7.png'
import img8 from '@/assets/img/wingo/8.png'
import img9 from '@/assets/img/wingo/9.png'

export const wingoImages = {
  red,
  green,
  violet,
  0: img0,
  1: img1,
  2: img2,
  3: img3,
  4: img4,
  5: img5,
  6: img6,
  7: img7,
  8: img8,
  9: img9
}
